import NextAuth from "next-auth";
import { authConfig } from "./auth.config";

export const MIN_NAME_LENGTH = 2;
export const MAX_NAME_LENGTH = 64;
export const MIN_PASSWORD_LENGTH = 5;
export const MAX_PASSWORD_LENGTH = 64;

export const { handlers, auth, signIn, signOut } = NextAuth(authConfig);
